<template>
  <v-data-table
    :headers="sharkCarHeaders"
    :items="golfCarData"
    :loading="_loading"
    :footer-props="{
      'items-per-page-options': [50, 100, 150],
    }"
    class="elevation-1"
    :server-items-length="total"
    :options.sync="options"
    @click:row="goTo"
    @update:options="_getReportInstances(options)"
  >
  <template v-slot:item.network_status="{ item }" >
        <v-icon :color="item.network_status" x-large>
          mdi-circle-medium</v-icon>
      </template>
    <template
        v-slot:item.launch_mode="{ item }"
      >
        {{ formatLaunchMode(item.launch_mode) }}
    </template>
    <template
      v-slot:item.last_activity="{ item }"
    >
      {{ formatDate(item.last_activity) }}
    </template>
    <template
      v-slot:item.group_name="{ item }"
    >
      <div class="text-capitalize">
        {{ item.group_name }}
      </div>
    </template>
  </v-data-table>
</template>
<script>
// import Tables from "@/components/app/Table";
import { mapGetters, mapMutations, mapActions } from 'vuex';
import FormatDate from '@/mixins/FormatDate';
import FormatLaunchMode from '@/mixins/FormatLaunchMode';
import Options from '@/mixins/Options';
import { MobileView } from '@/mixins';

export default {
  props: ['golfCarData'],
  components: {
    // Tables
  },
  mixins: [MobileView, FormatDate, Options, FormatLaunchMode],
  data: () => ({
    sharkCarHeaders: [
      { text: '', value: 'network_status' },
      { text: 'Golf Car', value: 'car_number' },
      { text: 'Launch Mode', value: 'launch_mode' },
      { text: 'Shark Car ID', value: 'gpsi_car_id' },
      { text: 'GPSi Car #', value: 'gpsi_car_number' },
      { text: 'Course', value: 'group_name' },
      { text: 'Shark Version', value: 'version' },
      { text: 'Device UUID', value: 'uuid' },
      { text: 'MDN', value: 'mdn' },
      { text: 'IMEI', value: 'imei' },
      { text: 'Last Activity', value: 'last_activity' },
    ],
  }),
  computed: {
    ...mapGetters({
      _getQueryParams: 'reports/getQueryParams',
      _client: 'account/getCurrentClient',
      _loading: 'reports/getScreensTableLoading',
    }),
    total() {
      return this.golfCarData[0] ? parseInt(this.golfCarData[0].total) : 0;
    },
    queryParams: {
      get() {
        return this._getQueryParams;
      },
      set(val) {
        this._setQueryParams(val);
      },
    },
  },
  methods: {
    ...mapMutations({
      _setQueryParams: 'reports/setQueryParams',
    }),
    ...mapActions({
      _getReportInstances: 'reports/acquireSessions',
    }),
    goTo(item) {
      this.$router.push(`/${this._client.client_name.toLowerCase()}/screens/${item.uuid}`);
    },
    getGroupName(id) {
      let screenGroup = null;
      this._client.groups.map((group) => {
        if (group.uuid === id) {
          screenGroup = group;
        }
      });
      if (screenGroup) {
        return screenGroup.group_name;
      }
      return id;
    },
  },
};
</script>
